import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgWarningDrawn = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Frame",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Subtract",
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M24.4841 10.8227C19.8953 10.8227 8.48634 30.3486 10.0599 35.9275C10.8466 38.7167 31.0414 41.5058 38.9091 38.7167C46.7769 35.9276 29.0733 8.03332 24.4841 10.8227ZM26.9134 17.6225C26.7589 18.6402 25.7381 22.2973 25.168 24.3396L25.1679 24.3398C24.9728 25.0387 24.8305 25.5485 24.7938 25.6986C24.6498 26.2876 24.1759 27.6334 23.5869 27.4565C23.1263 27.3181 22.9311 26.5101 22.7859 25.9095L22.7859 25.9094C22.7454 25.7418 22.7088 25.5903 22.6714 25.4741C22.5 24.9412 20.6925 17.8581 20.5197 17.1515C20.3037 16.2682 20.8842 14.7374 22.0318 14.7374C22.4274 14.7374 22.7095 14.7514 22.9818 14.7649H22.9818C23.4993 14.7906 23.9817 14.8145 25.1422 14.7374C26.9134 14.6196 27.1726 15.9151 26.9134 17.6225ZM25.285 31.9466C25.5314 32.866 25.0575 34.1575 23.9267 34.3513C22.9713 34.6073 21.9971 34.0695 21.7508 33.1501C21.5044 32.2307 22.0539 31.1833 23.0092 30.9273C23.9646 30.6713 25.0387 31.0272 25.285 31.9466Z",
					fill: "#E2E2E4"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Ellipse 540",
					d: "M24.8257 32.1637C25.1044 33.2039 24.6223 34.6506 23.4208 34.849C22.4074 35.1205 21.3599 34.4974 21.0812 33.4572C20.8025 32.4171 21.3694 31.2467 22.3828 30.9751C23.3962 30.7036 24.547 31.1235 24.8257 32.1637Z",
					stroke: "#1B1B20",
					strokeWidth: 2.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector 744",
					d: "M7.15644 34.2514C5.53136 28.4986 16.9792 9.52474 22.4014 8.20082C27.1409 5.32443 45.0758 34.2515 36.9504 37.1276C28.825 40.0036 7.96893 37.1276 7.15644 34.2514Z",
					stroke: "#1B1B20",
					strokeWidth: 2.5
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector 1046",
					d: "M26.364 17.6231C26.1566 18.9891 24.3884 25.1103 24.2444 25.6992C24.1004 26.2881 23.6265 27.6339 23.0375 27.457C22.4484 27.2801 22.2933 26.0075 22.122 25.4746C21.9506 24.9417 20.1431 17.8586 19.9703 17.152C19.7543 16.2687 20.3348 14.7379 21.4823 14.7379C22.6299 14.7379 22.8216 14.8557 24.5928 14.7379C26.364 14.6201 26.6232 15.9156 26.364 17.6231Z",
					stroke: "#1B1B20",
					strokeWidth: 2.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		})
	})
});
export default SvgWarningDrawn;
